import {Component, OnInit, ViewChild} from '@angular/core';
import Swal from 'sweetalert2';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {CharacteristicsService} from '../../../../../services/characteristics.service';
import {ProductTypeService} from '../../../../../services/productType.service';
import {Validation} from '../../../error/error-messages/validator-messages';
import {Characteristics, ICharacteristics} from '../../../../../models/characteristics.model';
import {ProductType} from '../../../../../models/productType.model';
import {nameValidator_v1} from '../../../validators/validator';
import {AuthService} from '../../../../../services/auth.service';
import {RoleService} from '../../../../../services/role.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-characteristics',
  templateUrl: './characteristics.component.html',
  styleUrls: ['./characteristics.component.scss']
})
export class CharacteristicsComponent implements OnInit {
  @ViewChild('closebutton') closebutton;
  @ViewChild('closebutton2') closebutton2;

  get f() { return this.editForm.controls; }
  get f1() { return this.characteristicForm.controls; }

  constructor(private fb: FormBuilder, private characteristicService: CharacteristicsService,
              private productTypeService:ProductTypeService, private authService: AuthService,
              private roleService: RoleService,private router: Router) { }

  // @ts-ignore
  characteristic: Characteristics[] = [];

  // @ts-ignore
  updateCharacteristic: ICharacteristics = {};

  /*
-----------------------------         for all page attribute    --------------------------------
*/
  perPage: number = 10;
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 25, 50, 100];
  search: any;
  totalItems :any;
  // @ts-ignore
  productType: ProductType[] = [];
  subProduct: ProductType = {};
  characteristicTab: any[] = [];

  sorted = false;
  sorted1 = false;
  sorted2= false;
  sorted3 = false;

  // @ts-ignore
  user: User = [];

  editForm = this.fb.group({
      id: [],
      name: new FormControl('', {validators: nameValidator_v1('Le nom ', 2, 100), updateOn: 'change'}),
      description: new FormControl('', [Validation.descriptionValidator("La description")]),
      productType: new FormControl('', [Validators.required]),
      isRequiredValue: new FormControl('', [ Validation.requiredValidator("Veuillez définir si cette caractéristique est obligatoire ou non")]),
  });


  characteristicForm = this.fb.group({
    name: new FormControl('',{validators: nameValidator_v1('Le nom ',2,100), updateOn: 'change'}),
    description: new FormControl('',[ Validation.descriptionValidator("La description")]),
    productType: new FormControl('', [ Validation.requiredValidator("La sous-catégorie"),]),
    isRequiredValue: new FormControl('',[ Validation.requiredValidator("Veuillez définir si cette caractérisque est obligatoire ou non"),]),
  });

  ngOnInit(): void {
    this.loadCharacteristics();
    this.loadProductType();
    this.loadPersonalInformation();
  }

  keyPressAlphanumeric(event) {
    var inp = String.fromCharCode(event.keyCode);

    if (!/[!ùç@#~µ¨$%°£§^&*$0-9()_+\=\[\]{};:"\\|,.<>\?]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  isViewAuditAutorized = false;
  isKahpoo: boolean;
  loadPersonalInformation = () => {
    this.authService.getUSerBySessionId().subscribe(
      (rest: any) => {
        this.user = rest;
        this.isKahpoo = rest.kahpoo;
        rest.minimizedRoles.forEach(r => {
          this.roleService.getidRole(r).subscribe(r => {
            if (r.name.includes("BACK_OFFICE")) {
              this.isViewAuditAutorized = true;
            }
          })
        })
      }, (error: any) => {
        //console.log(error);
      }
    );
  }

  loadCharacteristics = () => {
    this.characteristicService.getAllCategories_v1(this.page-1, this.perPage, this.search).subscribe(data => {
      this.characteristic = data.content;
      this.totalItems = data.totalElements;
    }, (err) => {
    });
  }

  onTableSizeChange(event: any){
    if(event.target.value === 'Tous'){
      this.perPage = this.totalItems;
    }else{
      this.perPage = event.target.value;
    }
    this.loadCharacteristics();
  }

  onEditCharacteristics(c: ICharacteristics) {
    this.updateCharacteristic = c;
    // console.log("Caractéristique éditer");
    // console.log(this.updateCharacteristic);
    this.editForm.patchValue({
      id: this.updateCharacteristic.id,
      name: this.updateCharacteristic.name,
      description: this.updateCharacteristic.description,
      productType: this.updateCharacteristic.productType.id,
      isRequiredValue: this.updateCharacteristic.isRequiredValue ? 'oui' : 'non',
    });
  }

  resetcharacteristicForm(){
    this.characteristicForm.get('name').setValue('');
    this.characteristicForm.get('description').setValue('');
    this.characteristicForm.get('productType').setValue('');
  }

  normalizeString(str) {
    return str
      .toLowerCase()
      .replace(/[àáâãäå]/g, "a")
      .replace(/[ç]/g, "c")
      .replace(/[èéêë]/g, "e")
      .replace(/[ìíîï]/g, "i")
      .replace(/[ñ]/g, "n")
      .replace(/[òóôõö]/g, "o")
      .replace(/[ùúûü]/g, "u")
      .replace(/[ýÿ]/g, "y")
      .replace(/[^a-z0-9]/g, ""); // Supprime tous les caractères qui ne sont pas des lettres ou des chiffres
  }

  hideErrorMessage(value: string) {
    //console.log("Chhhhhhhhh")
    this.existingCharacteristic = null;
    this.displayExistingErrorMessage = '';
    // if (value === ''){
    //   this.displayExistingErrorMessage = '';
    // }
  }

  getSubCategory(idSubCategory: any){
   // console.log(idSubCategory);
    this.subProduct = this.productType.find(pt => pt.id === Number(idSubCategory));
  }


  displayExistingErrorMessage: string = '';
  existingCharacteristic :any;
  onCharacteristicsFormSubmit() {
    const name = this.characteristicForm.get('name')?.value;
    const characteristic: Characteristics = this.characteristicForm.value;
    characteristic.productType = this.subProduct;
    const productTypeId = characteristic.productType.id;
    const selectIfRequiredValue = this.characteristicForm.get('isRequiredValue')?.value;
    if(selectIfRequiredValue && selectIfRequiredValue==='oui'){
      characteristic.isRequiredValue = true;
    }else{
      characteristic.isRequiredValue = false;
    }
    this.existingCharacteristic = this.characteristic.find(c => this.normalizeString(c.name) === this.normalizeString(name) && c.productType.id === Number(productTypeId));

    //console.log(existingCharacteristic);

    if(this.existingCharacteristic){
      this.displayExistingErrorMessage = 'Cette caractéristique existe déjà pour cette sous-catégorie.';
      return;
    }else {
      this.displayExistingErrorMessage = '';
    }
    // console.log("Ajout d'une nouvelle caractéristique...");
    // console.log(characteristic)
    this.characteristicService.saveCharacteristics(characteristic).subscribe(rs => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'La caractéristique a été ajoutée avec succés"',
        showConfirmButton: false,
        timer: 1500
      });
      this.loadCharacteristics();
      this.close();
      this.resetcharacteristicForm();
      this.reloadComponent();
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez vérifier les données',
        showConfirmButton: false,
        timer: 2500
      });
    });
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  hideErrorMessageEdit(value: string){
    if (value === ''){
      this.alreadyExistValue = '';
    }
  }

  alreadyExistValue: string = '';
  onEditFormSubmit() {
    const characteristic: Characteristics = this.editForm.value;
    characteristic.productType = this.productType.find(p => p.id === this.editForm.get('productType')?.value);
    this.alreadyExistValue = '';
    const selectIfRequiredValue = this.editForm.get('isRequiredValue')?.value;
    if(selectIfRequiredValue && selectIfRequiredValue==='oui'){
      characteristic.isRequiredValue = true;
    }else{
      characteristic.isRequiredValue = false;
    }
    // console.log("Caractéristique modifier ...");
    // console.log(characteristic);
    this.characteristicService.updateCharacteristics(characteristic).subscribe(rs => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'La caractéristique a été modifiée avec succés"',
        showConfirmButton: false,
        timer: 1500
      });
      this.resetcharacteristicForm();
      this.reloadComponent();
      this.loadCharacteristics();
      this.close();
    }, 
    error =>{
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: error.error.errorMessage,
        showConfirmButton: false,
        timer: 2500
      });
    });
  }

  deleteCharacteristics(id: any) {
    if(this.isViewAuditAutorized){
      Swal.fire({
        title: 'SUPPRESSION',
        text: 'Voulez-vous vraiment supprimer cette caractéristique ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'OUI',
        denyButtonText: `NON`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.characteristicService.deleteCharacteristics(id).subscribe(
            rs => {
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'La caractéristique a été supprimée avec succés"',
                showConfirmButton: false,
                timer: 1500
              });
              this.loadCharacteristics();
            }, error => {
              Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: error.error.errorMessage,
                showConfirmButton: false,
                timer: 2500
              })
            }
        );
        } else if (result.isDenied) {
          Swal.fire({
            icon: 'error',
            text: 'Suppression annulée',
          })
        }
      });
    }else{
      Swal.fire({
        icon: 'error',
        text: 'Vous n\'êtes pas autorisé à supprimer une caractéristique.',
      })
    }

  }

  deleteListCharacteristics() {
    if(this.characteristicTab.length <= 0) {
      Swal.fire({
        position: 'top-end',
        icon: 'info',
        title: 'Veuillez selectionner les caractéristiques à supprimer',
        showConfirmButton: false,
        timer: 3000
      });

      return
    }
    if(this.isViewAuditAutorized){
      Swal.fire({
        title: 'SUPPRESSION',
        text: 'Voulez-vous vraiment supprimer ces caractéristiques ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'OUI',
        denyButtonText: `NON`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          console.log("this.characteristicTab", this.characteristicTab)
          this.characteristicService.deleteListCharacteristics(this.characteristicTab).subscribe(
            rs => {
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'La caractéristique a été supprimée avec succés"',
                showConfirmButton: false,
                timer: 1500
              });
              this.loadCharacteristics();
              this.characteristicTab = []
            }, error => {
              Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: error.error.errorMessage,
                showConfirmButton: false,
                timer: 2500
              })
            }
        );
        } else if (result.isDenied) {
          Swal.fire({
            icon: 'error',
            text: 'Suppression annulée',
          })
        }
      });
    }else{
      Swal.fire({
        icon: 'error',
        text: 'Vous n\'êtes pas autorisé à supprimer une caractéristique.',
      })
    }

  }

  loadProductType = () => {
    this.productTypeService.getProductType()
      .subscribe(data => {
        this.productType = data;
      }, (err) => {
       // console.log('-----> err', err);
      });
  }


  /*
  -----------------------------          for all page methodes      -----------------------------
   */

  displayPerPage(value: any) {
    this.tableSize = parseInt(value, 10);
    //console.log(this.tableSize);
  }

  isSearch = false;
  searchFilter($event: KeyboardEvent) {
    this.isSearch = true;
    this.characteristicService.getAllCategories_v1(this.page-1, this.perPage, this.search).subscribe(data => {
      this.characteristic = data.content;
      this.totalItems = data.totalElements;
    }, (err) => {
    });
    // this.characteristicService.getCharacteristics().subscribe(data => {
    //   this.characteristic = data;
    //   this.characteristic = this.characteristic.filter(value =>
    //     value.name?.toLowerCase().trim().includes(this.search.toLowerCase().trim()) ||
    //     value.description?.toLowerCase().trim().includes(this.search.toLowerCase().trim()) ||
    //     value.productType?.name?.toLowerCase().trim().toLowerCase().includes(this.search.toLowerCase().trim())
    //   );
    // }, (err) => {
    // });
  }
  
  /*
  end for all page
   */
  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.characteristic.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.characteristic.sort((a, b) => a.name < b.name ? 1 : a.name > b.name ? -1 : 0)
      this.sorted1 = false;
    }
  }

  sort2() {
    if(this.sorted2 == false) {
      // @ts-ignore
      this.characteristic.sort((a, b) => a.description > b.description ? 1 : a.description < b.description ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.characteristic.sort((a, b) => a.description < b.description ? 1 : a.description > b.description ? -1 : 0)
      this.sorted2 = false;
    }
  }

  sort3() {
    if(this.sorted3== false) {
      // @ts-ignore
      this.characteristic.sort((a, b) => a.productType.name > b.productType.name ? 1 : a.productType.name < b.productType.name ? -1 : 0)
      this.sorted3 = true;
    } else {
      // @ts-ignore
      this.characteristic.sort((a, b) => a.productType.name < b.productType.name ? 1 : a.productType.name > b.productType.name ? -1 : 0)
      this.sorted3 = false;
    }
  }

  close() {
    this.closebutton.nativeElement.click();
    this.closebutton2.nativeElement.click();
  }

addCharacteristicToDelete(event: Event, ch: any) {
  const checkbox = event.target as HTMLInputElement;

  console.log("ch", ch);
  console.log("event", checkbox.checked);

  if (checkbox.checked) {
    if (!this.characteristicTab.includes(ch)) {
      this.characteristicTab.push(ch);
    }
    console.log("ch ajouté :", this.characteristicTab);
  } else {
    const myIndex = this.characteristicTab.findIndex(item => item.id === ch.id);
    if (myIndex !== -1) {
      this.characteristicTab.splice(myIndex, 1);
    }
    console.log("ch supprimé :", this.characteristicTab);
  }

  console.log("characteristicTab :", this.characteristicTab);
}
}

